<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links" v-for="(stats, index) in getStats">
        <!-- {{ getStats }} -->
        <sidebar-link :to="stats.to" :name="stats.name" :icon="stats.icon" />
        <!-- <sidebar-link to="/dashboard" name="Inicio" icon="ti-home"/>
          <sidebar-link to="/usuarios" name="Usuarios" icon="ti-user" />
          <sidebar-link to="/estaciones" name="Estaciones" icon="ti-truck" />
          <sidebar-link to="/direcciones" name="Direcciones" icon="ti-book" />
          <sidebar-link to="/descargar-tareas" name="Configuración" icon="ti-settings" />
          <sidebar-link to="/tareas-estacion" name="Tareas" icon="ti-view-list-alt" />
          <sidebar-link to="/descargar-respaldo" name="Respaldos" icon="ti-cloud-down" /> -->
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import state from "../../store/state";
// import auth  from "../../token";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent
  },
  data() {
    return {
      statsCards: []
    };
  },
  created() {
    this.statsCards = state.menu;
  },
  computed: {
    getRol() {
      let att = JSON.parse(localStorage.getItem('attributes'));
      let roles = [];
      for (let key in att) {
        if (att.hasOwnProperty(key)) {
          if (att[key][0] === 'false') roles.push({ id: key, value: true })
        }
      }
      return roles;
    },
    getStats() {
      const stats = [{ to: "/dashboard", name: "Inicio", icon: "ti-home" }];
      for (let i = 0; i < this.statsCards.length; i++) {
        for (let j = 0; j < this.getRol.length; j++) {
          if (this.statsCards[i].rol === this.getRol[j].id) {
            stats.push(this.statsCards[i])
          }
        }
      }
      return stats;
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
